import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, imageSlot, rect } from "./kit";
import type { LabelTemplate } from "./types";

// Plate on black, authored MCC-first on the 80 × 100 label; the wine label is
// the same design re-bottled (it gains 5 mm of air each side). The plate is a
// gold edge with no fill: an upload always moves to the back of the stack
// (elements.ts placeImage), so a filled plate would hide the logo.
function mcc(): CanvasData {
  const b = "mcc";
  return doc(b, INK.black, [
    imageSlot({ x: 23, y: 15, width: 34, height: 22 }, "Add your logo"),
    rect(INK.gold, { x: 20, y: 12, width: 40, height: 28 }, 0.4),
    hairline(INK.gold, 40, 48, 26),
    centred(b, { text: "YOUR HOUSE", font: "cinzel", size: 5, color: INK.gold, baseline: 57, tracking: 0.2 }),
    centred(b, { text: "Méthode Cap Classique", font: "cormorant", italic: true, size: 2.8, color: INK.gold, baseline: 64, tracking: 0.03 }),
    centred(b, { text: "Brut · 2026", font: "montserrat", size: 1.8, color: INK.gold, baseline: 88, tracking: 0.25 }),
  ]);
}

export const logoPlateDark: LabelTemplate = {
  key: "logo-plate-dark",
  name: "Plate on black",
  occasion: "sparkling",
  style: "Logo in a gold-edged plate",
  description: "Your logo in a gold-edged plate on black for Cap Classique — send a light version of your logo.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "mcc" ? mcc() : rebottle(mcc(), bottle)),
};
